// extracted by css-extract-rspack-plugin
export default {"select":"select-wcss41","prefsTable":"prefsTable-xUJfIu"};